import { WeekNavigationComponent } from './week-navigation.component';

export default angular
  .module('sfMobile.components.week-navigation', [
    'sfMobile.services.localization',
    'sfMobile.services.dates',
  ])
  .component('sfWeekNavigation', WeekNavigationComponent).name;
